module.exports = __webpack_public_path__ + "S_left_click.fadfd2c1.png";